import { motion } from "framer-motion";
import { Phone, WhatsappLogo, Envelope, ArrowRight, MapPin } from "@phosphor-icons/react";
import AnimatedSection from "@/components/layout/AnimatedSection";
import { COMPANY, fadeUp, WHATSAPP_QUOTE_URL } from "@/data/site";

const Contact = ({ showHeading = true }) => {
  return (
    <AnimatedSection id="contato" className="section-padding bg-white">
      <div className="container-custom">
        {showHeading && (
          <motion.div variants={fadeUp} className="text-center mb-12">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#E73336] mb-4 block">
              Entre em Contato
            </span>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#234D89] mb-4">
              Fale Conosco
            </h2>
            <div className="section-divider mx-auto" />
          </motion.div>
        )}

        <motion.div
          variants={fadeUp}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto"
        >
          <div
            data-testid="contact-phone"
            className="text-center p-6 bg-[#F5F5F5] rounded-2xl"
          >
            <div className="w-14 h-14 bg-[#234D89] rounded-full flex items-center justify-center mx-auto mb-4">
              <Phone size={24} weight="fill" className="text-white" />
            </div>
            <h3 className="text-lg font-semibold text-[#234D89] mb-2">Telefone</h3>
            <a
              href={COMPANY.phoneHref}
              className="text-[#5C5C5C] hover:text-[#E73336] transition-colors"
            >
              {COMPANY.phone}
            </a>
          </div>

          <div
            data-testid="contact-whatsapp"
            className="text-center p-6 bg-[#F5F5F5] rounded-2xl"
          >
            <div className="w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center mx-auto mb-4">
              <WhatsappLogo size={24} weight="fill" className="text-white" />
            </div>
            <h3 className="text-lg font-semibold text-[#234D89] mb-2">WhatsApp</h3>
            <p className="text-[#5C5C5C] mb-3">{COMPANY.whatsapp}</p>
            <a
              href={WHATSAPP_QUOTE_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-whatsapp-button"
              className="inline-flex items-center gap-2 text-sm font-medium text-[#25D366] hover:text-[#20BD5C]"
            >
              Clique para conversar
              <ArrowRight size={16} />
            </a>
          </div>

          <div
            data-testid="contact-email"
            className="text-center p-6 bg-[#F5F5F5] rounded-2xl"
          >
            <div className="w-14 h-14 bg-[#234D89] rounded-full flex items-center justify-center mx-auto mb-4">
              <Envelope size={24} weight="fill" className="text-white" />
            </div>
            <h3 className="text-lg font-semibold text-[#234D89] mb-2">E-mail</h3>
            <a
              href={`mailto:${COMPANY.email}`}
              className="text-[#5C5C5C] hover:text-[#E73336] transition-colors break-all"
            >
              {COMPANY.email}
            </a>
          </div>

          <div
            data-testid="contact-address"
            className="text-center p-6 bg-[#F5F5F5] rounded-2xl"
          >
            <div className="w-14 h-14 bg-[#E73336] rounded-full flex items-center justify-center mx-auto mb-4">
              <MapPin size={24} weight="fill" className="text-white" />
            </div>
            <h3 className="text-lg font-semibold text-[#234D89] mb-2">Endereço</h3>
            <a
              href={COMPANY.address.directionsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#5C5C5C] hover:text-[#E73336] transition-colors leading-snug block"
            >
              {COMPANY.address.street}
              <br />
              {COMPANY.address.district}
              <br />
              {COMPANY.address.city} — {COMPANY.address.zip}
            </a>
          </div>
        </motion.div>
      </div>
    </AnimatedSection>
  );
};

export default Contact;
